/* eslint-disable jsx-a11y/alt-text */
import { useRef } from "react";
import useOnScreen from "../hooks/useOnScreen";

export const TableWrapper = ({ children, dark = false, minHeight = "20vh", padding = "var(--landing-page-padding)" }) => {
    return <>
        <div className={"Table " + (dark && "dark")}>
            <div className="Table__content">
                {children}
            </div>
        </div>
        <style jsx>
            {`
            .Table {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                width: 100vw;
                min-height: ${minHeight};
                background: var(--off-white);
            }
            .Table.dark {
                background-color: var(--covalent-dark-blue);
                color: #fff;
            }

            .Table__content {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
                height: 100%;
                padding: ${padding};
                max-width: var(--landing-page-max-width);
                margin: 0 auto;
                width: 100%;
            }

        `}
        </style>
    </>;
};

export const TableContent = ({ data, graphic = false }) => {
    return <>
        <div  className="table__content">
            <table>
                <thead>
                    <tr >
                        {data.headers.map((o, i) => {
                            return <th align="left" key={i}>{o}</th>;
                        })}
                    </tr>
                </thead>
                <tbody>
                    {data.rows.map((o, i) => {
                        return <tr key={i}>
                            {o.data.map((c, i) =>{
                                if(c.title){
                                    return <td key={i} className={i === 0 ? "td-title" : ""}><a target="_blank" href={c.url}>{c.title}</a></td>;
                                }
                                if(graphic && i === 0 && c === ""){
                                    return <td key={i}><img alt="Covalent Coin" src="https://www.datocms-assets.com/86369/1679435255-covalent-cqt-animation_small.png"></img></td>;
                                }
                                return <td className={i === 0 ? "td-title" : ""} key={i}>{c}</td>;
                            })}
                        </tr>;
                    })}
                </tbody>
            </table>
        </div>
       
        <style jsx>
            {`
            :global(.table__content) {
                overflow:auto;
                width:100%;
                position: relative;
            }
            img{
                width:100px;
            }
            th{
                white-space: nowrap;
            }
            .td-title{
                white-space: nowrap;
                color: var(--pink);
                font-weight:var(--font-weight-bold);
            }

            td{
                min-width:12rem;
                font-size: var(--font-size-1);
                vertical-align: top;
            }
            .fixed-column {
                position: sticky;
                right: 0;
              }

            
        `}
        </style>
    </>;
};

export const TableTitle = ({ children }) => {
    const animatedRef = useRef<HTMLDivElement>(null);
    const isOnScreen = useOnScreen(animatedRef);

    return <>
        <h2 ref={animatedRef} className={"Table__title " + (isOnScreen && " TableTitleIsVisible ")}>
            {children}
        </h2>
        <style jsx>
            {`
            h2 {
                font-size: var(--font-size-7);
                margin-bottom: 1rem;
                line-height: 1.2;
            }
            :global(.dark .Table__title) {
                margin-bottom: 3rem;
            }
            .Table__title {
                opacity: 0;
            }
            .Table__title.TableTitleIsVisible {
                animation: fadeIn 0.5s ease-in-out forwards;
            }
        `}
        </style>
    </>;
};

export const TableSubtitle = ({ children }) => {
    const animatedRef = useRef<HTMLDivElement>(null);
    const isOnScreen = useOnScreen(animatedRef);

    return (
        <p ref={animatedRef} className={"Table__subtitle " + (isOnScreen && " Table__subtitle__on__screen")}>{children}
            <style jsx>{`
            .Table__subtitle {
                font-size: var(--font-size-4);
                line-height: var(--line-height-4);
                margin-bottom: 0rem;
                margin-top: 1rem;
                max-width: 66%;
                opacity: 0;
            }
            .Table__subtitle__on__screen {
                animation: fadeIn 0.5s ease-in-out forwards;
                z-index: 1;
            }
            @media (max-width: 768px) {
                .Table__subtitle {
                    max-width: 100%;
                }
            }
        `}</style></p>
    );
};

export const TableHighlightTitle = ({ children, dark = false }) => {
    return <>
        <div className={"Table-highlight-title " + (dark && "dark")}>
            <h2 className="Table-highlight-title__content">
                {children}
            </h2>
        </div>
        <style jsx>
            {`
            .Table-highlight-title {
                font-size: var(--font-size-5);
            }
            .Table-highlight-title.dark {
                background-color: var(--covalent-dark-blue);
                color: #fff;
            }
            .Table-highlight-title__content {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
                height: 100%;
                max-width: var(--landing-page-max-width);
                margin: 0 auto;
                width: 100%;
                font-size: var(--font-size-7);
                margin-bottom: 1rem;
                line-height: 1.2;
            }
            @media (max-width: 768px) {
                .Table-highlight-title {
                    flex-direction: column;
                    height: auto;
                }
                .Table-highlight-title__content {
                    width: 100%;
                    height: auto;
                }
            }
        `}
        </style>
    </>;
};


